import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const HeaderBox = styled(Box)(({ theme }) => ({
  marginBottom: '50px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '30px',
  },
}));

export const FaqItemsWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(7),
  maxWidth: '1000px',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 490px)',
  gap: '20px',
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, minmax(300px, 490px))',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const CtaWrapper = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginTop: '50px',
  [theme.breakpoints.down('md')]: {
    marginTop: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '30px',
  },
}));
